import React from "react";

const items = [
  "Excelência em Saúde & Estética",
  "Cuidado Personalizado",
  "Beleza Natural",
  "Ambiente Acolhedor",
  "Jundiaí · SP",
];

export const Marquee = () => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-clinic-line/60 bg-clinic-ink py-5 md:py-6 overflow-hidden select-none"
    >
      {/* Side Fade Gradient Overlays */}
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-clinic-ink to-transparent z-10" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-clinic-ink to-transparent z-10" />

      <div className="flex w-max animate-marquee gpu-accel">
        {row.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-clinic-bg/90 px-6 sm:px-8 whitespace-nowrap font-normal">
              {t}
            </span>
            <span className="text-clinic-pink text-xl sm:text-2xl opacity-80">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

